import { useFerve } from "./FerveProvider"

export function useFerveMode() {
  if (env.admin) return "sff"
  const ferve = useFerve()
  return ferve.mode
}
